import { ComponentProps, memo, PropsWithChildren } from "react"
import { StyleSheet, Text, View, Switch, Platform } from "react-native"
import { ItemLabel } from "src/components/parts/ItemLabel"
import { LoadingIndicator } from "src/components/parts/LoadingIndicator"
import { Colors } from "src/constants/Colors"
import { useUserDevicePushSettingData } from "src/components/projects/NotificationSettings/useUserDevicePushSettingData"

const Card = memo<PropsWithChildren>(({ children }) => {
  return <View style={cardStyles.card}>{children}</View>
})

const cardStyles = StyleSheet.create({
  card: {
    borderWidth: 1,
    borderColor: Colors.white2,
    borderRadius: 10,
    paddingLeft: 16,
    marginTop: 8,
    marginBottom: 16,
  },
})

const trackColor = { true: Colors.orange, false: Colors.white6 }
const thumbColor = Colors.white3

const CustomSwitch = memo<Pick<ComponentProps<typeof Switch>, "value" | "onValueChange" | "disabled">>((props) => (
  <Switch
    {...props}
    thumbColor={thumbColor}
    trackColor={trackColor}
    {...Platform.select({ web: { activeThumbColor: thumbColor } })}
  />
))

export const PushSetting = memo(() => {
  const { isLoading: optInIsLoading, optInState, updateNewOptIn, isUpdatingNewOptIn } = useUserDevicePushSettingData()

  if (optInIsLoading) {
    return (
      <View style={styles.loadingContainer}>
        <LoadingIndicator />
      </View>
    )
  }

  return (
    <View style={styles.container}>
      <ItemLabel label="イチオシ" />
      <Card>
        <View style={styles.cardItem}>
          <Text style={styles.label}>プッシュ通知</Text>
          <CustomSwitch
            value={optInState}
            onValueChange={(value) => {
              updateNewOptIn(value)
            }}
            disabled={isUpdatingNewOptIn}
          />
        </View>
      </Card>
    </View>
  )
})

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
  },
  loadingContainer: {
    padding: 16,
    justifyContent: "center",
    alignItems: "center",
  },
  label: {
    fontSize: 16,
    color: Colors.greyshBrown,
  },
  cardItem: {
    paddingRight: 16,
    paddingVertical: 8,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  cardFirstItem: {
    borderBottomWidth: 1,
    borderBottomColor: Colors.white2,
  },
})
